import { useParams } from 'react-router-dom';

type DesignDetailParams = {
    compositeId: string;
};

export const useDesignDetailParams = () => useParams<DesignDetailParams>();
